import {createGlobalStyle} from 'styled-components';
import { mainTheme } from './themes';
import LoginBackgroundImg from "./static/img/login-bg.png";

export const GlobalStyles = createGlobalStyle`
  * {
    border: 0;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  ::before,
  ::after {
    box-sizing: inherit;
  }

  html,
  body {
    overflow-x: hidden;
    width: 100%;
    height: 100%;
  }

  html {
    font-size: 10px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${mainTheme.font.default};
    font-size: ${mainTheme.font.size.text.default};
    line-height: ${mainTheme.font.lineHeight.default};
    /* -webkit-appearance: none; */
    padding: 0;
    background: ${mainTheme.backgroundColor.body};
    color: ${mainTheme.textColor.default};
  }

  #app,
  #root {
    height: 100%;
  }

  ${'' /* p {
    font-size: inherit;
    color: inherit;
  } */}

  a {
    text-decoration: none;
  }

  .link {
    text-decoration: none !important;
    margin-top: 22px !important;
    color: #487bf2 !important;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  button {
    font-family: Roboto;
    font-weight: 500;
    font-size: 15px;
  }

  ${'' /* button {
    font-family: ${mainTheme.font.default};
    font-size: ${mainTheme.font.size.text.default};
    background: 0;
    color: inherit;
    &:focus {
      outline: 0;
    }
    &:hover {
      cursor: pointer;
    }
  } */}

  ${'' /* h1 {
    font-size: ${mainTheme.font.size.heading.h1};
    font-weight: ${mainTheme.font.weight.regular};
  }

  h2 {
    font-size: ${mainTheme.font.size.heading.h2};
    font-weight: ${mainTheme.font.weight.regular};
  }
  
  h3 {
    font-family: ${mainTheme.font.accent};
    font-size: ${mainTheme.font.size.heading.h3};
  } */}

  h1, h2, h3, h4, h5, h6 {
    font-family: Roboto;
    font-weight: 500;
  }

  img {
    max-width: 100%;
  }

  label {
    font-size: ${mainTheme.font.size.text.extrasmall};
  }

  input:not([type="submit"]),
  select,
  textarea {
    font-family: inherit;
    font-size: ${mainTheme.font.size.text.default};
    padding: 1.2rem 1.5rem;
    background: transparent;
    color: ${mainTheme.textColor.input.placeholder};
    border: 1px solid ${mainTheme.border.input.default};
    border-radius: ${mainTheme.borderRadius.default};

    &:active,
    &:focus {
      color: ${mainTheme.textColor.default};
      border-color: ${mainTheme.border.input.active};
    }

    &:focus {
      outline: 0;
    }
  }

  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input.meter-input {
    padding: 1.2rem 3rem 1.2rem 1.5rem;
  }

  input:not([type="submit"]):not([type="checkbox"]),
  select,
  textarea {
    width: 100%;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: linear-gradient(45deg, transparent 50%, ${mainTheme.textColor.input.placeholder} 50%), linear-gradient(135deg, ${mainTheme.textColor.input.placeholder} 50%, transparent 50%);
    background-position: calc(100% - 2rem), calc(100% - 1.5rem);
    background-size: .5rem .5rem;
    background-repeat: no-repeat;
  }

  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: ${mainTheme.textColor.input.placeholder};
  }

  ::-moz-placeholder { /* Firefox 19+ */
    color: ${mainTheme.textColor.input.placeholder};
  }

  :-ms-input-placeholder { /* IE 10+ */
    color: ${mainTheme.textColor.input.placeholder};
  }

  :-moz-placeholder { /* Firefox 18- */
    color: ${mainTheme.textColor.input.placeholder};
  }

  ol,
  ul {
    list-style: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .input-error {
    font-size: 13px;
    color: red;
  }

  .message-box {
    h3 {
      margin: 15px 0px;
    }

    img {
      margin-right: 20px;
    }
  }

  .error-box {
    background: #DE5E56;
    border-radius: 3px;
    padding: 20px 25px;
    margin: 30px 0px;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: row;

    .title {
      font-weight: bold;
    }

    a {
      width: 100%;
    }
  }

  .success-box {
    background: #83D2A7;
    border-radius: 3px;
    padding: 20px 25px;
    margin: 30px 0px;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: row;

    .title {
      font-weight: bold;
    }

    a {
      width: 100%;
    }
  }

  .auth-page {
    background-color: #2f2f2f;
  }

  .auth-page-description {
    // background-color: rgba(255, 255, 255, 0.1);
  }

  .link-underline {
    text-decoration: underline !important;
  }

  .input-wrapper-valid input {
    border: 1px solid #15C67D !important;
    border-radius: 5px;
  }

  .input-wrapper-invalid input {
    border: 1px solid #DE5E56 !important;
    border-radius: 5px;
  }

  .input-valid-check {
    position: absolute;
    right: 14px;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
  }

  .w100 {
    width: 100%
  }

  mb15 {
    margin-bottom: 15px;
  }

  mb20 {
    margin-bottom: 20px;
  }

  mb25 {
    margin-bottom: 25px;
  }

  mb30 {
    margin-bottom: 25px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .mt10 {
    margin-top: 10px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .mr20 {
    margin-right: 20px;
  }

  .ft-1-7 {
    font-size: 1.7rem;
  }

  .ft-1-5 {
    font-size: 1.5rem;
  }

  .ft-1-3 {
    font-size: 1.3rem;
  }

  .w50 {
    width: 50%;
  }

  .remember-wrapper {
    margin-top: 35px;
    display: flex;
    justify-content: center;
  }

  .register-name-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .swal2-height-auto {
    height: 100% !important;
  }

  body.swal2-height-auto {
    height: 100% !important;
  }

  .MuiAccordion-root {
    position: initial !important;
  }

  .login-page {
    background-image:url(${LoginBackgroundImg});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .auth-right-section {
    background-image:url(${LoginBackgroundImg});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &.custom-signup-page {
      background: rgba(23, 25, 30, 0.75);
    }
  }

  .custom-signup-page {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background: rgba(23, 25, 30, 0.75);
  }

  .z-index-2 {
    z-index: 2;
  }

  .custom-checkbox {
    input {
      padding: 0;
      height: initial;
      width: initial;
      margin-bottom: 0;
      display: none;
      cursor: pointer;
      
      &:checked + label:before {
        border: 2px solid #E5E5E5;
      }

      &:disabled + label:before {
        border: 2px solid #5A5A5A;
      }

      &:checked + label:after {
        content: '';
        display: block;
        position: absolute;
        top: 4px;
        left: 5.5px;
        width: 5px;
        height: 9px;
        border: solid #E5E5E5;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }

    label {
      position: relative;
      cursor: pointer;
      margin: 0;

      &:before {
        content:'';
        -webkit-appearance: none;
        background-color: transparent;
        border: 2px solid #A0A0A0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
        padding: 6px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        border-radius: 3px;
      }
    }

    @keyframes customSimplePulse {
      0% { transform: scale(1); opacity: 1; }
      70% { transform: scale(2); opacity: 0; }
      100% { transform: scale(4); opacity: 0; }
    }
  }

`
